import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import {
  EArbitrageFilters,
  ECexPairFilters,
  EDexPairFilters,
  EGeneralFilters,
  EProjectFilters,
  ESolPairFilters,
  IFilters,
} from 'types/filters';
import { ICexPair, IDexPair } from 'types/pairs';

import { getProjectFiltersKey } from '../utils';

interface IPayload {
  id: string;
  filter?: any;
  dex?: {
    pair?: IDexPair;
    type: EDexPairFilters;
  };
  cex?: {
    pair?: ICexPair;
    type: ECexPairFilters;
  };
  sol?: {
    pair?: IDexPair;
    type: ESolPairFilters;
  };
  general?: EGeneralFilters;
  arbitrage?: EArbitrageFilters;
  project?: {
    projectId: number;
    type: EProjectFilters;
  };
}

const update = (filter: any, id: string, filters?: any[]) => {
  const newFilters = [...(filters ?? [])];

  const findFilterIdx = newFilters.findIndex(el => el.id === id);

  if (findFilterIdx === -1) return newFilters.concat(filter);

  newFilters[findFilterIdx] = filter;

  return newFilters;
};

export const updateFilterReducer: CaseReducer<IFilters, PayloadAction<IPayload>> = (
  state,
  { payload },
) => {
  const { id, filter, cex, dex, sol, general, arbitrage, project } = payload;

  const updatedAt = new Date(Date.now()).toISOString();

  if (general) {
    state[general].filters = update(filter, id, state[general]?.filters);

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (arbitrage) {
    state.arbitrage[arbitrage].filters = update(filter, id, state.arbitrage[arbitrage]?.filters);

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (project) {
    const key = getProjectFiltersKey(project.projectId, project.type);
    const projectEntry = state.project[key];

    if (!projectEntry) return;

    state.project[key] = {
      updated_at: updatedAt,
      filters: update(filter, id, projectEntry.filters),
      setted: projectEntry.setted,
    };

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  const key = cex ? 'cex' : dex ? 'dex' : 'sol';
  const type = cex ? cex.type : dex ? dex.type : sol ? sol.type : undefined;
  const pairId = cex ? cex.pair?.id : dex ? dex.pair?.id : sol ? sol.pair?.id : undefined;

  if (!pairId || !state[key][pairId] || !type) return;

  state[key][pairId]!.updated_at = updatedAt;

  //@ts-ignore
  state[key][pairId].filters[type].filters = update(
    filter,
    id,
    //@ts-ignore
    state[key][pairId].filters[type].filters,
  );

  LocalStorage.set(FILTERS_CACHE_KEY, state);
};
